import { memo } from "react";
import { useStore } from "../../store/globalState";
import { useNavigate } from "react-router-dom";
import { AuraLayout, Layout } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { PayoutInfo } from "../../components/PayoutInfo";
import { MailStrokeIcon, WhatsAppStrokeIcon } from "../../assets/icons";
import { TITLE_COLOR } from "../../constants";
import { Navbar } from "../../components/Navbar";

/**
 * Gallery-safe m2m "Contact / Need help" screen (ported from SupportPageV2).
 *
 * Production opens WhatsApp / mailto deep links and copies the email to the
 * clipboard; here the rows are inert placeholders — no live links, no toast,
 * no claim-link side effects. Every color is bound to the active theme.
 */
export const SupportV2Page = memo(() => {
  const { t } = useTranslation("m2m");
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { dropzoneColors } = colorConfig;
  const navigate = useNavigate();

  return (
    <AuraLayout colorConfig={colorConfig} className="white-view-background">
      <Layout.Header>
        <Navbar
          onBackClick={() => navigate(-1)}
          title={t("contact.title")}
          align="center"
          color={TITLE_COLOR}
        />
      </Layout.Header>
      <Layout.Content>
        <section className="support-page-v2-container">
          <PayoutInfo
            title={t("contact.whatsapp")}
            subtitle=""
            color={TITLE_COLOR}
            icon={<WhatsAppStrokeIcon size={24} colors={dropzoneColors} />}
          />
          <PayoutInfo
            title={t("contact.email")}
            subtitle=""
            color={TITLE_COLOR}
            icon={<MailStrokeIcon size={24} colors={dropzoneColors} />}
          />
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
